// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/grid-row","root":"grid-row-m__root__1NF-y","selected":"grid-row-m__selected__3CrpA","selectable":"grid-row-m__selectable__YPZgp"};